import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import AssigneeTransactionSelect from "components/AssigneeTransactionSelect";

import { GridTransactionInternal } from "types";

interface Props extends ICellRendererParams {
  data: GridTransactionInternal;
  canAssign: boolean;
}

const AssigneeRenderer = (props: Props) => {
  const { data, canAssign } = props;

  return (
    <AssigneeTransactionSelect
      transaction={data}
      canAssign={canAssign}
      assigneeId={data.assigneeId!}
      assigneeName={data.assigneeDisplayName}
    />
  );
};

export default AssigneeRenderer;
